import { Address } from '../address/address.model';

export enum EventCategory {
  WORKSHOP = 'workshop',
  SURVEY = 'survey',
  OTHER = 'other',
}

export enum EventStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  ALL = 'all',
}

export enum UserRegistrationStatus {
  SIGNED_UP = 'signed_up',
  WAITLISTED = 'waitlisted',
  OTHER = 'other',
}

export enum ResidencePlace {
  URBAN = 'Stadtumgebung',
  RURAL = 'Ländlich',
  UNSPECIFIED = 'Keine Angabe',
}

export enum SalutationStatus {
  MR = 'Herr',
  MS = 'Frau',
  MX = 'Neutral',
}

export function stringToSalutationStatus(value: string): SalutationStatus | undefined {
  return Object.values(SalutationStatus).find(v => v === value);
}

export interface IUserInterestsProfile {
  id: string;
  salutation: SalutationStatus;
  firstName: string;
  lastName: string;
  email: string;
  telefonCountryCode: string;
  telefonNumber: string;
  birthyear: string;
  placeOfResidence: ResidencePlace;
}

export interface CommunityEvent {
  id: string;
  status: EventStatus;
  category: EventCategory;
  title: string;
  description?: string;
  shortDescription?: string;
  location?: string;
  userRegistrationStatus?: UserRegistrationStatus;
}

export interface CommunityEventDetails extends CommunityEvent {
  startTime: string;
  endTime: string;
  fullyBooked: boolean;
  maxParticipants?: number;
  registeredParticipants?: number;
  waitingParticipants?: number;
  address?: Address;
}
